import React, { FC } from 'react';
import {
  cssTransition,
  ToastContainer as ToastifyContainer,
} from 'react-toastify';
import './ToastContainer.css';

const SlideUp = cssTransition({
  enter: `bbBeyond-toast bbBeyond-toast-enter`,
  exit: 'bbBeyond-toast bbBeyond-toast-exit',
});

const ToastContainer: FC = () => {
  return (
    <ToastifyContainer
      position="bottom-left"
      transition={SlideUp}
      hideProgressBar
      pauseOnHover
      draggable={false}
    />
  );
};

export default ToastContainer;
